const envToCheckoutUrlMap: Record<string, string> = {
  dev: 'https://checkout-v2-dev.appcharge.com',
  staging: 'https://checkout-v2-staging.appcharge.com',
  sandbox: 'https://checkout-v2-sandbox.appcharge.com',
  production: 'https://checkout-v2.appcharge.com',
}; // need to add this in the CI after cashapp POC

export function getCheckoutUrl() {
  const env = process.env?.REACT_APP_ENV;
  return envToCheckoutUrlMap[env as string];
}
